// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__12Mnk","colMin":"styles_colMin__3v1KS","colCheckbox":"styles_colCheckbox__3NBu8"};